import styled from "styled-components";
import DatePicker from "react-datepicker";

export const MainDiv = styled.div`
  margin: auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
`;
export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  position: relative;
`;
export const DiagnosticImgContainer = styled.div`
  margin-right: 10px;
  padding: 8px 10px;
  width: 80px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px 0px 0px 4px;
  background-color: #f15a24;
`;
export const DiagnosticImg = styled.img`
  width: 24px;
  height: 24px;
`;
export const DiagnosticTitle = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SeparatorDiv = styled.div`
  margin: 0 8px;
  width: 2px;
  height: 100%;
  background-color: #e3e3e3;
`;
export const PrescriptionDaysDiv = styled.div`
  margin-right: 10px;
  width: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const PrescriptionDaysAligner = styled.div`
  width: 180px;
  display: flex;
  border: 40px;
  gap: 2px;
`;
export const InputCheckboxDiv = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: ${({ borderRadius }) => borderRadius && borderRadius};
  background-color: ${({ background }) => background && background};
`;
export const DayText = styled.p`
  font-size: 12px;
  color: ${({ color }) => color && color};
`;
export const DiagnosticPrescriptionInfo = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const OpenButton = styled.button`
  width: 33px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-left: 2px solid rgb(230, 230, 230);
  background: transparent;
  position: absolute;
  right: 0;
  cursor: pointer;
`;
export const OpenButtonImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const Body = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
`;
export const DiagnosticProtocolsInfo = styled.p`
  margin-bottom: 16px;
  color: #808080;
  font-size: 14px;
  font-weight: 400;
`;
export const DiagnosticDatesAligner = styled.div`
  margin-bottom: 2px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const DiagnosticDatesDiv = styled.div`
  padding: 0 10px;
  width: 95%;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: ${({ border }) => border && border};
  background-color: ${({ background }) => background && background};
`;
export const DiagnosticTitleDiv = styled.div`
  width: 210px;
  display: flex;
  align-items: center;
`;
export const DiagnosticDateDiv = styled.div`
  padding: 4px 8px;
  width: 120px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
`;
export const DiagnosticDateText = styled.p`
  color: #808080;
  font-size: 14px;
  font-weight: 400;
`;
export const StatusDiv = styled.div`
  margin: 0 20px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ background }) => background && background};
  gap: 4px;
`;
export const StatusText = styled.p`
  color: #fff;
  font-size: 10px;
  font-weight: 600;
`;
export const StatusImg = styled.img`
  width: 12px;
  height: 12px;
`;
export const OpenPopupButton = styled.button`
  height: fit-content;
  border: none;
  background: transparent;
  cursor: pointer;
  pointer-events: ${({ clickable }) => (clickable ? "auto" : "none")};
`;
export const OpenPopupImg = styled.img`
  width: 24px;
  height: 24px;
`;
export const PopupDiv = styled.div`
  padding: 16px;
  width: fit-content;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background-color: #fff;
`;
export const DiagnosticPopupTitle = styled.p`
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;
export const DiagnosticDatePopupDiv = styled.div`
  margin-top: 16px;
  padding: 10px;
  width: 340px;
  display: flex;
  justify-content: space-around;
  border-radius: 4px;
  background-color: #f3f3f3;
`;
export const InputDateDiv = styled.div`
  width: 120px;
`;
export const InputDate = styled(DatePicker)`
  padding: 5px 10px;
  width: 120px;
  border: ${({ border }) => border && border};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const ActionsDiv = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: sticky;
  bottom: 0;
`;
export const CancelButton = styled.button`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid #26a9b6;
  background: #fff;
  color: #26a9b6;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const SaveButton = styled.button`
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background: #26a9b6;
  box-shadow: 0px 1px 0px 0px #1c7983;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
